export default __webpack_public_path__ + "static/media/communes.9e9f3075.yml";